<script setup>
import { computed } from 'vue';
import {
    status_projeto_rascunho,
    status_projeto_emexecucao,
    status_projeto_inativo,
    status_projeto_cancelado,
    status_projeto_concluido,
} from '@/commons/projetos';

const props = defineProps({
    status: String,
});

const coresPorStatus = {
    [status_projeto_rascunho]: 'amarelo',
    [status_projeto_emexecucao]: 'verde',
    [status_projeto_inativo]: 'cinza',
    [status_projeto_cancelado]: 'vermelho',
    [status_projeto_concluido]: 'cyan',
    aditivado: 'roxo',
};

const cor = computed(() => coresPorStatus[props.status] ?? 'cinza');
const icone = computed(() => (props.status !== 'aditivado' ? 'pi-circle-fill' : null));
</script>

<template>
    <TagBase :valor="status" :cor="cor" :icone="icone" classe="capitalize" />
</template>
